import React from 'react';
import { Route } from 'react-router-dom';
import IncomeManagement from '@/pages/accounts/IncomeManagement';
import ExpenseManagement from '@/pages/accounts/ExpenseManagement';
import CashBalance from '@/pages/accounts/CashBalance';
import BankBalance from '@/pages/accounts/BankBalance';
import BankRegister from '@/pages/accounts/BankRegister';
import CashRegister from '@/pages/accounts/CashRegister';
import CreateBank from '@/pages/accounts/CreateBank';
import IncomeCategory from '@/pages/accounts/IncomeCategory';
import ExpensesCategory from '@/pages/accounts/ExpensesCategory';
import CreateSuppliers from '@/pages/accounts/CreateSuppliers';
import IncomeReport from '@/pages/accounts/IncomeReport';
import AccountsSuppliersReport from '@/pages/accounts/SuppliersReport';
import SuppliersLedger from '@/pages/accounts/SuppliersLedger';
import SuppliersPayment from '@/pages/accounts/SuppliersPayment';
import PaySalary from '@/pages/accounts/PaySalary';
import PayCommission from '@/pages/accounts/PayCommission';
import AssetsEntry from '@/pages/accounts/AssetsEntry';
import DepreciationSetting from '@/pages/accounts/DepreciationSetting';
import AssetsReport from '@/pages/accounts/AssetsReport';
import LiabilitiesEntry from '@/pages/accounts/LiabilitiesEntry';
import InterestSetting from '@/pages/accounts/InterestSetting';
import IncomeExpensesReport from '@/pages/accounts/IncomeExpensesReport';
import ProfitLoss from '@/pages/accounts/ProfitLoss';
import BalanceSheet from '@/pages/accounts/BalanceSheet';
import AccountsReports from '@/pages/accounts/AccountsReports';
import PurchaseEntry from '@/pages/accounts/PurchaseEntry';

export const accountsRoutes = (
  <React.Fragment>
    <Route path="accounts/income" element={<IncomeManagement />} />
    <Route path="accounts/income-management" element={<IncomeManagement />} />
    <Route path="accounts/expense" element={<ExpenseManagement />} />
    <Route path="accounts/expense-management" element={<ExpenseManagement />} />
    <Route path="accounts/cash-register" element={<CashRegister />} />
    <Route path="accounts/bank-register" element={<BankRegister />} />
    <Route path="accounts/cash-balance" element={<CashBalance />} />
    <Route path="accounts/bank-balance" element={<BankBalance />} />
    <Route path="accounts/create-bank" element={<CreateBank />} />
    <Route path="accounts/add-bank" element={<CreateBank />} />
    <Route path="accounts/income-category" element={<IncomeCategory />} />
    <Route path="accounts/expenses-category" element={<ExpensesCategory />} />
    <Route path="accounts/expense-category" element={<ExpensesCategory />} />
    <Route path="accounts/create-suppliers" element={<CreateSuppliers />} />
    <Route path="accounts/suppliers" element={<CreateSuppliers />} />
    <Route path="accounts/income-report" element={<IncomeReport />} />
    <Route path="accounts/suppliers-report" element={<AccountsSuppliersReport />} />
    <Route path="accounts/suppliers-ledger" element={<SuppliersLedger />} />
    <Route path="accounts/suppliers-payment" element={<SuppliersPayment />} />
    <Route path="accounts/pay-salary" element={<PaySalary />} />
    <Route path="accounts/pay-commission" element={<PayCommission />} />
    <Route path="accounts/assets-entry" element={<AssetsEntry />} />
    <Route path="accounts/depreciation-setting" element={<DepreciationSetting />} />
    <Route path="accounts/assets-report" element={<AssetsReport />} />
    <Route path="accounts/liabilities-entry" element={<LiabilitiesEntry />} />
    <Route path="accounts/interest-setting" element={<InterestSetting />} />
    <Route path="accounts/income-expenses-report" element={<IncomeExpensesReport />} />
    <Route path="accounts/profit-loss" element={<ProfitLoss />} />
    <Route path="accounts/balance-sheet" element={<BalanceSheet />} />
    <Route path="accounts/reports" element={<AccountsReports />} />
    <Route path="accounts/purchase-entry" element={<PurchaseEntry />} />
  </React.Fragment>
);
